import React from 'react';
import { Link } from 'react-router-dom';

// import svg
import SvgTextureLineShort from 'js/components/svg/Svg.texture_line_short';

import { useInView } from 'react-intersection-observer';
import { motion, useAnimation } from 'framer-motion';

const variants = {
  hidden: {
    opacity: 0,
    scale: 0, // Start scale at 0
  },
  visible: (index) => ({
    opacity: 1,
    scale: 1, // End scale at 1
    rotate: [0, 4, -4, 0], // Rotate between 0 and 2 degrees
    transition: {
      type: 'spring', // Use spring for a bounce effect
      stiffness: 120, // Tightness of the spring
      damping: 10, // Control the spring bounce
      delay: Math.random() * 0.8 + 0.2, // Alternate delay logic
    },
  }),
  hover: {
    scale: 1.05, // End scale at 1
    rotate: [0, 4, -4, 0], // Rotate between 0 and 2 degrees
  },
};

const desc_variants = {
  hidden: {
    opacity: 0,
  },
  visible: (index) => ({
    opacity: 1,
    transition: {
      delay: 1.75, // Alternate delay logic
    },
  }),
};

const CarouselCharactersBlock = ({ item }) => {
  const { name = '', cta_image = '', friendly_url } = item;

  return (
    <motion.div
      className="content-item content-item--characters"
      key={name + '-carousel'}
      whileHover="hover"
      variants={variants}
    >
      <Link to={`/meet-the-characters/${friendly_url}`} className="content-item__container">
        <figure>
          <img src={cta_image} alt={''} title={''} />
        </figure>
        <div className="content-item__body">
          <SvgTextureLineShort color={'#fff'} />
          <h2>{name}</h2>
        </div>
      </Link>
    </motion.div>
  );
};

const ContentItemCharactersBlock = ({ item, carousel = false, display_desc = false }) => {
  if (carousel) {
    return <CarouselCharactersBlock item={item} />;
  }

  const { name = '', cta_image = '', friendly_url, description } = item;

  const controls = useAnimation();

  const { ref, inView } = useInView({
    threshold: 0.15,
    triggerOnce: true,
  });

  React.useEffect(() => {
    inView && controls.start('visible');
  }, [inView]);

  React.useEffect(() => {
    controls.start('hidden');
  }, []);

  return (
    <motion.div
      className="content-item content-item--characters"
      key={name}
      variants={variants}
      animate={controls}
      ref={ref}
    >
      <motion.div key={name + '-hover-container'} whileHover="hover" variants={variants}>
        <Link to={`/meet-the-characters/${friendly_url}`} className="content-item__container">
          <figure>
            <img src={cta_image} alt={''} title={''} />
          </figure>
          <div className="content-item__body">
            <SvgTextureLineShort color={'#fff'} />
            <h2>{name}</h2>
          </div>
        </Link>
      </motion.div>
      {display_desc && (
        <motion.p key={`${name}-desc`} variants={desc_variants} initial="hidden" animate={controls}>
          {description}
        </motion.p>
      )}
    </motion.div>
  );
};

export default ContentItemCharactersBlock;
